import { render, staticRenderFns } from "./PreferencesSelectType.vue?vue&type=template&id=4242e2be"
import script from "./PreferencesSelectType.vue?vue&type=script&lang=js"
export * from "./PreferencesSelectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports